import { render, staticRenderFns } from "./Votecount.vue?vue&type=template&id=6652de4e&"
import script from "./Votecount.vue?vue&type=script&lang=js&"
export * from "./Votecount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports